module.exports = __webpack_public_path__ + "static/media/result_fhl_id.7dc27d64.jpg";